import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '/', // Proxy will handle /gsd requests
  timeout: 50000
})

// Request interceptor
service.interceptors.request.use(
  config => {
    const sessionId = localStorage.getItem('sessionId')
    if (sessionId) {
      config.headers['sessionId'] = sessionId
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // 处理401未授权错误
    if (res.code === 401) {
      Message({
        message: res.message || '登录凭证已过期，请重新登录',
        type: 'error',
        duration: 3 * 1000
      })
      // 清除登录信息
      localStorage.removeItem('sessionId')
      localStorage.removeItem('userInfo')
      // 跳转到登录页
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000)
      return Promise.reject(new Error(res.message || '登录凭证已过期'))
    }
    // Assuming code 1 is success based on OpenAPI description "0-失败；1-成功；"
    if (res.code !== 1) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 处理HTTP状态码401
    if (error.response && error.response.status === 401) {
      Message({
        message: '登录凭证已过期，请重新登录',
        type: 'error',
        duration: 3 * 1000
      })
      // 清除登录信息
      localStorage.removeItem('sessionId')
      localStorage.removeItem('userInfo')
      // 跳转到登录页
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000)
      return Promise.reject(error)
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
